import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CreateMaterialRequirementAttributes, MaterialRequirement } from "../_models/material-requirement.interface";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MaterialRequirementService {

  constructor(private http: HttpClient) { }

  createMaterialRequirement(material_requirement: CreateMaterialRequirementAttributes) {
    const path = environment.apiURL + `material_requirements`
    return this.http.post<MaterialRequirement>(path, { material_requirement })
  }

  updateMaterialRequirement(id: number | string, material_requirement: CreateMaterialRequirementAttributes) {
    const path = environment.apiURL + `material_requirements/${id}`
    return this.http.patch<MaterialRequirement>(path, { material_requirement })
  }

  destroyMaterialRequirement(id: number | string) {
    const path = environment.apiURL + `material_requirements/${id}`
    return this.http.delete<MaterialRequirement>(path)
  }
}
